import { render, staticRenderFns } from "./LoginComponentNavigationButton.vue?vue&type=template&id=64037bbc&scoped=true"
import script from "./LoginComponentNavigationButton.vue?vue&type=script&lang=ts"
export * from "./LoginComponentNavigationButton.vue?vue&type=script&lang=ts"
import style0 from "./LoginComponentNavigationButton.vue?vue&type=style&index=0&id=64037bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64037bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
